import { render } from "./SmallContentBase.vue?vue&type=template&id=6d4bd37f&scoped=true"
import script from "./SmallContentBase.vue?vue&type=script&lang=js"
export * from "./SmallContentBase.vue?vue&type=script&lang=js"

import "./SmallContentBase.vue?vue&type=style&index=0&id=6d4bd37f&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4bd37f"]])

export default __exports__